import { render, staticRenderFns } from "./SpkbDetail.vue?vue&type=template&id=53584615&"
import script from "./SpkbDetail.vue?vue&type=script&lang=js&"
export * from "./SpkbDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports